<template>
  <div
    class="coupon-container"
    :class="{ mobile: isMobile }"
    v-if="!isEnd"
  >
    <div class="new-coupon">
      <div class="cundown-left">
        <span class="conpon-title">{{ title }}</span>
        <Countdown
          :endTime="endTime"
          type="dd/hh/mm/ss"
          @end="isEnd = true"
        ></Countdown>
      </div>
      <div class="use-coupon" @click="useCoupon">
        {{buttonText}}
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import Countdown from '@/components/common/countdown';
export default {
  name: 'CouponBanner',
  components: {
    Countdown
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: i18n.t('upgrade_page_views_vip_center_index_444')
    }
  },
  data() {
    return {
      isEnd: false
    };
  },
  computed: {
    endTime() {
      const time = Date.now();
      const end = time + 86400 * 7 * 1000;
      return end;
    },
    isMobile() {
      return window.innerWidth < 600;
    }
  },
  methods: {
    useCoupon() {
      this.$emit('use-coupon');
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.coupon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;
  background: #fe7f38;
  padding: 0 10px;
  width: 200px;
  flex: auto;
}
.new-coupon {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 900px;
  color: #ffffff;
}
.cundown-left {
  display: flex;
  /deep/.time-num {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    width: 24px;
    font-size: 14px;
    background: #ffe1cf;
    border-radius: 3px;
    color: #ff5b37;
  }
  /deep/ .time-unit {
    font-size: 20px;
    transform: scale(0.5) translateY(10px);
  }
}
.conpon-title {
  margin-right: 12px;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
}
.use-coupon {
  display: flex;
  align-items: center;
  @include button-yellow;
  height: 24px;
  padding: 0 22px;
  border-radius: 40px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
}
.coupon-container {
  &.mobile {
    padding: 0 10px;
    .cundown-left {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      justify-content: center;
    }
    .conpon-title {
      font-size: 12px;
    }
    /deep/ .countdown-container {
      .time-num {
        border: none;
        background-color: inherit;
        color: white;
        width: auto;
        height: auto;
        font-size: 12px;
      }
      .time-unit {
        transform: none;
        font-size: 12px;
      }
    }
  }
}
</style>
